/**
 * api 関数作成処理
 * From: 1.0.0
 *
 * @packageDocumentation
 */

import { AppError } from '../models/errors';
import { UnsafeObjectType } from '../utils/UtilityTypes';
import { commonMethod } from './base/fetch';

export const apiGenerator = () => ({
  get: commonMethod('GET'),
  post: commonMethod('POST'),
  put: commonMethod('PUT'),
  delete: commonMethod('DELETE'),
});

export const toQueryString = (queryObject: UnsafeObjectType | undefined) =>
  queryObject ? `?${new URLSearchParams(queryObject).toString()}` : '';

export const errorBoundaryPredicator = (error: unknown) =>
  // AppError で severity が WARNING の場合は、ErrorBoudary に流さない(各機能側で処理する)
  error instanceof AppError && error.severity === 'WARNING' ? false : true;
